import {Injector, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './modules/app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {
  HTTP_INTERCEPTORS,
  HttpBackend, HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  withXsrfConfiguration
} from "@angular/common/http";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {ApiInterceptor} from "./services/api/api.interceptor";
import {LoggerModule, NgxLoggerLevel} from "ngx-logger";
import {LocaleProvider} from "./services/locale.provider";
import {ServicesModule} from "./services/services.module";
import {LanguageInterceptor} from "./services/language-route-interceptor";
import {FooterComponent} from "./modules/shared/components/footer/footer.component";
import {HeaderComponent} from "./modules/shared/components/header/header.component";
import {CartHeaderComponent} from "./modules/shared/components/cart-header/cart-header.component";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {ModalModule} from "ngx-bootstrap/modal";

declare global {
  type UUID = string;
}

export function createTranslateLoader(httpBackend: HttpBackend) {
  return new TranslateHttpLoader(new HttpClient(httpBackend), 'assets/i18l/', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  bootstrap: [
    AppComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HeaderComponent,
    CartHeaderComponent,
    FooterComponent,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpBackend]
      }
    }),
    LoggerModule.forRoot({
      level: NgxLoggerLevel.DEBUG,
      serverLogLevel: undefined,
      serverLoggingUrl: undefined
    }),
    ServicesModule,
    ModalModule.forRoot()
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      deps: [Injector],
      multi: true
    },
    LocaleProvider,
    LanguageInterceptor,
    provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({
      cookieName: 'XSRF-TOKEN',
      headerName: 'X-XSRF-TOKEN',
    }))
  ]
})
export class AppModule {
  constructor(private langInterceptor: LanguageInterceptor) {
    this.langInterceptor.initialize();
  }
}
